import { createTheme } from '@mui/material/styles'

const yellow = '#F2e500'
const yellowLight = '#FDF065'
const blackDark = '#1E1E1E'

const theme = createTheme({
	shadows: [0, 1, 2, 3],
	shape: {
		borderRadius: 28,
	},
	palette: {
		primary: {
			main: yellow,
			light: yellowLight,
			dark: '#0059B2',
		},
		secondary: {
			main: '#009EBA',
			dark: '#0059B2',
		},
		warning: {
			main: '#FF6B45',
		},
		success: {
			main: '#6EBD8F',
		},
		text: {
			primary: blackDark,
			secondary: '#333333',
			disabled: '#C4C4C4',
			greyLight: '#343434',
			white: '#F9F7F4',
			publish: '#868686',
		},
		bgcolor: {
			beige: '#F9F7F4',
		},
	},
	typography: {
		fontSize: 14,
		fontFamily: ['museomoderno', 'montserrat'].join(','),
		notfoundtitle: {
			fontSize: 40,
			fontWeight: 800,
			color: blackDark,
		},
		button: {
			fontSize: 14,
			maxHeight: 33,
			marginLeft: 8 * 6,
		},
		headerTitleHome: {
			background: 'black',
			color: 'white',
			fontWeight: 900,
			letterSpacing: 2,
			textTransform: 'uppercase',
			fontSize: 18,
			display: 'table',
			margin: '4rem auto 1rem',
			padding: '.2rem 1rem',
			flexGrow: 0,
		},
		headerSubtitleHome: {
			margin: '.5rem auto',
			fontSize: 40,
			fontWeight: 800,
			maxWidth: 730,
			textAlign: 'center',
			lineHeight: 1.3,
		},
		headerParagrapheHome: {
			textAlign: 'center',
			maxWidth: 810,
			margin: '.5rem auto',
			fontSize: 18,
		},
		headerTitleList: {
			color: 'white',
			backgroundColor: 'black',
			fontSize: 16,
			padding: '.25rem .687rem',
			marginBottom: '0.6rem',
		},
		h2: {
			backgroundColor: yellow,
			display: 'table',
			fontSize: 40,
			padding: '8px 24px',
			fontWeight: 800,
		},
		p: {
			fontSize: 14,
			fontWeight: 400,
			color: blackDark,
			m: (theme) => theme.spacing(0, 8),
			p: 4,
		},
	},
	components: {},
	breakpoints: {
		values: {
			xs: 0,
			sm: 600,
			md: 1105,
			lg: 1330,
			xl: 1440,
		},
	},
})

export default theme
